import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popover-content" }
const _hoisted_2 = { class: "popover-item" }
const _hoisted_3 = { class: "popover-label" }
const _hoisted_4 = { class: "popover-value" }
const _hoisted_5 = { class: "popover-item" }
const _hoisted_6 = { class: "popover-label" }
const _hoisted_7 = { class: "popover-value" }
const _hoisted_8 = { class: "popover-item" }
const _hoisted_9 = { class: "popover-label" }
const _hoisted_10 = { class: "popover-value" }
const _hoisted_11 = { class: "popover-item" }
const _hoisted_12 = { class: "popover-label" }

export type FlowRecordPopoverItem = {
  id: string
  time: string
  title: string
  user: string
  status: 'approved' | 'rejected'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'flow-record-popover-detail',
  props: {
    item: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('listColumns.time')) + "：", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.time), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('approvalCenter.title')) + "：", 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.item.title), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('approvalCenter.operator')) + "：", 1),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.item.user), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('listColumns.result')) + "：", 1),
      _createElementVNode("span", {
        class: _normalizeClass(["popover-value", _ctx.item.status === 'approved' ? 'status-approved' : 'status-rejected'])
      }, _toDisplayString(_ctx.item.status === 'approved' ? _ctx.$t('approvalCenter.approvedLabel') : _ctx.$t('approvalCenter.rejectedLabel')), 3)
    ])
  ]))
}
}

})